"use_strict"

const $ = require('zepto-browserify').$;

class TopButton {
	constructor () {
		this.topButton = document.querySelector('#top-button');
		if ( !this.topButton ) return;

		this.initTopButton();
	}

	initTopButton () {
		const that = this;

		this.scrollingButton();
		window.addEventListener( 'scroll', that.scrollingButton.bind(that) );

		this.topButton.addEventListener( 'click', that.scrollToTop );
	}

	scrollingButton () {
		let scroll =  window.scrollY;
		let contentHeight = document.body.offsetHeight / 2 - window.innerHeight;

		if ( scroll > contentHeight ) {
		    this.topButton.classList.add('visible');
		} else {
		    this.topButton.classList.remove('visible');
		}
	}

	scrollToTop () {
		let scroll =  window.scrollY;
		let contentHeight = document.body.offsetHeight / 2 - window.innerHeight;

		if ( scroll > contentHeight ) {
			$( 'html, body' ).animate( {
		        scrollTop: $("#header").offset().top
		    }, 1000);
		}
	}
}

export { TopButton }
